import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import withRouteEvents from 'app/HOC/withRouteEvents';
import storage from 'app/services/storage';
import authModule from 'app/store/auth';
import bookingsModule from 'app/store/bookings';
import cinemasModule from 'app/store/cinemas';
import layoutModule from 'app/store/layout';
import informationModule from 'app/store/information';
import Layout from './Layout.component';
import technologies from 'app/store/technologies';

const { requestCinemas } = cinemasModule.actions;
const { requestLocations } = layoutModule.actions;
const { refreshTokenRequest } = authModule.actions;
const { barcodeRequest } = bookingsModule.actions;

const { requestFooterNewsLetter } = technologies.actions;

const { legalInfoContentRequest, fetchFooterNewsletterRegistration } = informationModule.actions;

const mapStateToProps = ({ layout, user, cinemas, information: { legalInfoContent, newsLetterResult }, technologies, bookings }) => (
  {
  isLoggedIn: !!user.user,
  userName: user.user ? user.user.firstName : null,
  user : user.user ? user.user : null,
  token: storage.getRefreshToken(),
  isLoading: layout.isLoading,
  error: layout.error,
  cinemas: cinemas.cinemas,
  locations: layout.locations,
  savedLocation: storage.getLocation(),
  elementsVisibility: layout.elementsVisibility,
  newsLetterContent: technologies.newsLetter,
  code: user?.cardNumber,
  barCode: bookings?.code,

  saveLocation: location => storage.setLocation(location),
  acceptCookiesAgreement: () => {
    storage.acceptCookiesAgreement();
    window.location.reload();
  },
  declineCookiesAgreement: () => storage.declineCookiesAgreement(),
  isRespondedToCookiesAgreement: !!storage.getCookiesAgreementStatus(),
  legalInfo: legalInfoContent,
  newsLetterResult: newsLetterResult
});

const mapDispatchToProps = {
  fetchcode: barcodeRequest,
  refreshToken: refreshTokenRequest,
  fetchCinemas: requestCinemas,
  getLocations: requestLocations,
  footerNewsLetter: requestFooterNewsLetter,
  getLegalInfo: legalInfoContentRequest,
  sendFooterNewsletterRegistration: fetchFooterNewsletterRegistration
};

export default compose(
  withRouter,
  withRouteEvents,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Layout);
